import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IPushRegistrationModel } from '@apps-common/types/portal/push-registration'

export const addOrUpdateMyMonitoringPushRegistration = async (model: IPushRegistrationModel): Promise<IPushRegistrationModel> =>
  axios.post(`/PushRegistration/MyMonitoringRegistration`, model).then((res) => res?.data?.data)

type Props = {
  model: IPushRegistrationModel
}

export const useMyMonitoringAddOrUpdatePushRegistration = (notify?: boolean, onSuccess?: (data: IPushRegistrationModel) => void) =>
  useMutation({
    retry: (failureCount, error: any) => {
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        return false
      }

      return true
    },
    mutationKey: ['addOrUpdateMyMonitoringPushRegistration'],
    mutationFn: ({ model }: Props) => addOrUpdateMyMonitoringPushRegistration(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Updated push registration.')
      }

      return data
    },
    onError: (error) => {
      if (notify) {
        toastError(error?.message || 'Failed to update push registration.')
      }
    },

    throwOnError: false
  })
